// extracted by mini-css-extract-plugin
module.exports = {"theme":"#0070C0"};